import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Switch from '@material-ui/core/Switch'
import Typography from '@material-ui/core/Typography'
import EditIcon from 'components/material-symbol/icons/Edit'
import OpenInNewOutlinedIcon from 'components/material-symbol/icons/OpenInNew'
import useSettingsStyles, { SettingsFormControlLabel } from '../settings.styles'
import { SettingsStatusBadge, SettingsToggleRow } from '../settings-components'
import { RULE_COPY, describeRule } from './constants'
import { RULE_ICONS } from './rule-icons'
import useStyles from './styles'

export function UpgradeBanner({ message, loading, onUpgrade }) {
  const classes = useStyles()

  return (
    <Box className={classes.upgradeBanner}>
      <Box className={classes.upgradeCopy}>
        <Typography className={classes.upgradeTitle}>
          Let PGA Coach follow up for you
        </Typography>
        <Typography className={classes.upgradeCaption}>
          {message} Turn one on and your message goes out automatically when a
          student cancels, is new, or stops booking. You can still edit your
          messages and send them yourself.
        </Typography>
      </Box>
      <Button
        variant="contained"
        color="primary"
        className={classes.pillButton}
        onClick={onUpgrade}
        disabled={loading}
        startIcon={<OpenInNewOutlinedIcon />}
      >
        Upgrade Now
      </Button>
    </Box>
  )
}

UpgradeBanner.propTypes = {
  message: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  onUpgrade: PropTypes.func.isRequired,
}

// One row per rule the coach can turn on.
export default function AutomationRuleRows({
  available,
  rules,
  editableTriggers,
  savingTrigger,
  onToggle,
  onEdit,
}) {
  const classes = useStyles()
  const settingsStyles = useSettingsStyles()

  return rules
    .filter(rule => RULE_COPY[rule.trigger])
    .map(rule => {
      const { title } = RULE_COPY[rule.trigger]
      return (
        <SettingsToggleRow
          key={rule.trigger}
          icon={RULE_ICONS[rule.trigger]}
          title={title}
          description={describeRule(rule.trigger, rule.delayDays)}
          action={
            <Box className={classes.ruleActions}>
              {editableTriggers.includes(rule.trigger) ? (
                <Button
                  color="primary"
                  className={classes.editButton}
                  onClick={() => onEdit(rule)}
                  startIcon={<EditIcon />}
                  aria-label={`Edit ${title}`}
                >
                  Edit
                </Button>
              ) : null}
              <Box className={classes.statusGroup}>
                <SettingsStatusBadge classes={settingsStyles}>
                  {rule.active ? 'On' : 'Off'}
                </SettingsStatusBadge>
                <SettingsFormControlLabel
                  label=" "
                  control={
                    <Switch
                      checked={rule.active}
                      disabled={
                        (!available && !rule.active) ||
                        savingTrigger === rule.trigger
                      }
                      onChange={event => onToggle(rule, event.target.checked)}
                      color="primary"
                      inputProps={{ 'aria-label': `Automate ${title}` }}
                    />
                  }
                />
              </Box>
            </Box>
          }
          classes={settingsStyles}
        />
      )
    })
}

AutomationRuleRows.propTypes = {
  available: PropTypes.bool.isRequired,
  rules: PropTypes.arrayOf(PropTypes.object).isRequired,
  editableTriggers: PropTypes.arrayOf(PropTypes.string).isRequired,
  savingTrigger: PropTypes.string,
  onToggle: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
}
